import React, { useState } from 'react';
import BasicModal from '../../newStudent/Modal/BasicModal';
import { IChatUser } from '../../../interfaces/chat/chat.interface';
import { HiChatAlt2, HiSearch, HiUserGroup, HiX } from 'react-icons/hi';
import * as S from './styles';
import { ButtonSimple } from '../../newStudent/Buttons';
import HeaderModal from '../../agent/HeaderModal';

interface INewChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  users: IChatUser[];
  onCreateChat: (userId: number) => Promise<void>;
  onCreateGroup?: (name: string, participantIds: number[]) => Promise<void>;
}

export default function NewChatModal({
  isOpen,
  onClose,
  users,
  onCreateChat,
  // onCreateGroup,
}: INewChatModalProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [isGroupMode, setIsGroupMode] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [groupName, setGroupName] = useState('');

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSelectUser = async (userId: number) => {
    if (isGroupMode) {
      setSelectedUsers((prev) => {
        if (prev.includes(userId)) {
          return prev.filter((id) => id !== userId);
        }
        return [...prev, userId];
      });
    } else {
      await onCreateChat(userId);
      onClose();
      setSearchTerm('');
    }
  };

  // const handleCreateGroup = async () => {
  //   if (!groupName.trim() || selectedUsers.length === 0) {
  //     return;
  //   }
  //   if (onCreateGroup) {
  //     await onCreateGroup(groupName.trim(), selectedUsers);
  //     onClose();
  //     setSearchTerm('');
  //     setSelectedUsers([]);
  //     setGroupName('');
  //     setIsGroupMode(false);
  //   }
  // };

  const handleClose = () => {
    onClose();
    setSearchTerm('');
    setSelectedUsers([]);
    setGroupName('');
    setIsGroupMode(false);
  };

  const handleRemoveSelected = (userId: number) => {
    setSelectedUsers((prev) => prev.filter((id) => id !== userId));
  };

  const selectedUsersList = users.filter((user) => selectedUsers.includes(user.id));

  return (
    <BasicModal
      isOpen={isOpen}
      setIsOpen={() => handleClose()}
      handleOnClose={handleClose}
      isFloat
      zIndex={1100}
    >
      <S.Container>
        <HeaderModal
          setOpen={handleClose}
          title={isGroupMode ? 'Novo Grupo' : 'Nova Conversa'}
          subtitle
          icon={isGroupMode ? <HiUserGroup size={24} /> : <HiChatAlt2 size={24} />}
          handleClose={() => {
            handleClose && handleClose();
          }}
        />
        <S.Content>
          {/* {!isGroupMode && onCreateGroup && (
            <S.ModeToggle>
              <ButtonSimple color="primary" font="p" widthSize="medium" heightSize="small" startIcon={<HiUserGroup size={14} />} onClick={() => setIsGroupMode(true)}>
                Criar Grupo
              </ButtonSimple>
            </S.ModeToggle>
          )} */}

          {isGroupMode && (
            <>
              <S.GroupNameInput
                type="text"
                placeholder="Nome do grupo"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
              {selectedUsersList.length > 0 && (
                <S.SelectedUsers>
                  <S.SelectedUsersLabel>Participantes selecionados:</S.SelectedUsersLabel>
                  <S.SelectedUsersList>
                    {selectedUsersList.map((user) => (
                      <ButtonSimple key={user.id}
                        icon={<HiX size={14} />}
                        color="primary"
                        widthSize="medium"
                        font="p"
                        onClick={() => handleRemoveSelected(user.id)}
                      >
                        {user.name}
                      </ButtonSimple>
                    ))}
                  </S.SelectedUsersList>
                </S.SelectedUsers>
              )}
            </>
          )}

          <S.Description>
            {isGroupMode
              ? 'Selecione os participantes do grupo:'
              : 'Selecione um contato para iniciar uma nova conversa:'}
          </S.Description>

          <S.SearchWrapper>
            <S.SearchIcon>
              <HiSearch />
            </S.SearchIcon>
            <S.SearchInput
              type="text"
              placeholder="Buscar contato..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </S.SearchWrapper>

          <S.UserList>
            {filteredUsers.length === 0 ? (
              <S.EmptyState>
                <S.EmptyText>Nenhum contato encontrado</S.EmptyText>
              </S.EmptyState>
            ) : (
              filteredUsers.map((user) => {
                const isSelected = selectedUsers.includes(user.id);
                return (
                  <S.UserItem
                    key={user.id}
                    onClick={() => handleSelectUser(user.id)}
                    $isSelected={isSelected}
                  >
                    <S.AvatarContainer>
                      {user.avatar ? (
                        <S.Avatar src={user.avatar} alt={user.name} />
                      ) : (
                        <S.AvatarPlaceholder>
                          {user.name.charAt(0).toUpperCase()}
                        </S.AvatarPlaceholder>
                      )}
                      {user.isOnline === true ? (
                        <S.OnlineBadge />
                      ) : user.isOnline === false ? (
                        <S.OfflineBadge />
                      ) : null}
                    </S.AvatarContainer>

                    <S.UserInfo>
                      <S.UserName>{user.name}</S.UserName>
                      <S.UserStatus>{user.isOnline ? 'Online' : 'Offline'}</S.UserStatus>
                    </S.UserInfo>

                    {isGroupMode && (
                      <S.Checkbox $isSelected={isSelected}>
                        {isSelected && '✓'}
                      </S.Checkbox>
                    )}
                    {!isGroupMode && (
                      <S.ChatIcon>
                        <HiChatAlt2 />
                      </S.ChatIcon>
                    )}
                  </S.UserItem>
                );
              })
            )}
          </S.UserList>

          {isGroupMode && (
            <S.Footer>
              <ButtonSimple color="gray" font="p" widthSize="medium" onClick={() => setIsGroupMode(false)}>
                Cancelar
              </ButtonSimple>
              {/* <ButtonSimple color="primary" font="p" widthSize="medium" onClick={handleCreateGroup} disabled={!groupName.trim() || selectedUsers.length === 0}>
                Criar Grupo ({selectedUsers.length})
              </ButtonSimple> */}
            </S.Footer>
          )}
        </S.Content>
      </S.Container>
    </BasicModal>
  );
}
